export default __webpack_public_path__ + "static/media/helm.57b2fac9.svg";